// Import Configs
import { generateCleanUrlParams } from 'services/Helpers';
import { CRMRequestService, getCancelableRequest, postCancelableRequest } from './http.config';
// Import Types
import type { ApprovalRequest, ApprovalRequestListItem, DataWithPaging } from 'types';

const ApprovalRequestHttpService = {
    getApprovalRequestList: () => {
        return postCancelableRequest<DataWithPaging<ApprovalRequestListItem>>({
            requestService: CRMRequestService,
            endpointPath: () => `/ApprovalRequest/List`,
        });
    },
    getApprovalRequestById: () => {
        return getCancelableRequest<ApprovalRequest>({
            requestService: CRMRequestService,
            endpointPath: ({ approvalRequestId }) =>
                `/ApprovalRequest/Get${generateCleanUrlParams({ id: approvalRequestId })}`,
        });
    },
    approveApprovalRequest: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/ApprovalRequest/Approve`,
        });
    },
    cancelApprovalRequest: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/ApprovalRequest/Cancel`,
        });
    },
    rejectApprovalRequest: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/ApprovalRequest/Reject`,
        });
    },
    assignApprovalRequest: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/ApprovalRequest/Assign`,
        });
    },
    unassignApprovalRequest: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ approvalRequestId }) =>
                `/ApprovalRequest/Unassign${generateCleanUrlParams({ approvalRequestId })}`,
        });
    },
};

export default ApprovalRequestHttpService;
